export default "__VITE_ASSET__D3KRIhS5__"